/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { BackupJobType } from '../models/BackupJobType';

export class BackupJobTypeFilters {
  /**
  * Matches if any item in this list equals `backupType`.
  */
  '_in'?: Array<BackupJobType>;
  /**
  * Matches if no item in this list equals `backupType`.
  */
  'notIn'?: Array<BackupJobType>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "_in",
      "baseName": "in",
      "type": "Array<BackupJobType>",
      "format": ""
    },
    {
      "name": "notIn",
      "baseName": "notIn",
      "type": "Array<BackupJobType>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return BackupJobTypeFilters.attributeTypeMap;
  }

  public constructor() {
  }
}

